import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {auth, firestore} from "../../config/firebaseConfig";
import {STATUS_FAILED, STATUS_IDLE, STATUS_PENDING} from "../../constants";
import {FILTER_STATUS_ALL} from "../../components/Po/constants";
import {initialState} from "../../components/orders/constants";

export const fetchOrders = createAsyncThunk(
    'orders/fetch',
    async ({filter = initialState, limit = 20, forceReset = false, forceForCurrentUser = false}, thunkAPI) =>     {
        return new Promise(async (resolve, reject) => {

            try {
                const {snapshot, orders} = thunkAPI.getState().orders;
                const shouldLoadMore = snapshot.filter === filter;

                let queryRef = firestore
                    .collection('orders')
                    .orderBy('Order.OrderedAt', 'desc');

                if (filter) {
                    if (filter.state && filter.state !== FILTER_STATUS_ALL.toLowerCase()) {
                        queryRef = queryRef.where('Order.State', '==', filter.state)
                    }

                    if (forceForCurrentUser || filter.user === 'you') {
                        queryRef = queryRef.where('Purchaser.Id', '==', auth.currentUser?.uid)
                    } else if (filter.user && filter.user !== 'all') {
                        queryRef = queryRef.where('Purchaser.Id', '==', filter.user)
                    }
                }

                if (shouldLoadMore && snapshot.cursor && !forceReset) {
                    queryRef = queryRef.startAfter(snapshot.cursor)
                }

                const docSnap = await queryRef.limit(limit).get();

                const result = docSnap.docs.map(doc => ({id: doc.id, ...doc.data()}));

                resolve({
                    orders: (shouldLoadMore && orders && !forceReset) ? [...orders, ...result] : [...result],
                    snapshot: {
                        cursor: docSnap.docs[docSnap.docs.length - 1],
                        filter: forceForCurrentUser ? {...filter, user: auth.currentUser?.uid} : filter,
                        noMoreResult: result.length < limit
                    }
                })

            } catch (e) {
                console.log(e)
                reject(e)
            }
        })
    }
)

export const updateOrder = createAsyncThunk(
    'orders/update',
    async ({order, onResolve}, thunkAPI) => {

        let copy = {...order};
        delete copy.id;

        await firestore.collection('orders').doc(order.id).update(copy);

        const {snapshot: {filter}} = thunkAPI.getState().orders;

        thunkAPI.dispatch(fetchOrders({filter: filter, forceReset: true}))

        onResolve && onResolve()

    }
)

export const deleteOrder = createAsyncThunk(
    'orders/delete',
    async ({orderId, onResolve}, thunkAPI) => {

        await firestore.collection('orders').doc(orderId).delete()

        const {snapshot: {filter}} = thunkAPI.getState().orders;

        thunkAPI.dispatch(fetchOrders({filter: filter, forceReset: true}))

        onResolve && onResolve()

    }
)

const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        orders: [],
        status: STATUS_IDLE,
        snapshot: {
            cursor: null,
            filter: initialState,
            noMoreResult: false
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchOrders.fulfilled, (state, {payload}) => {
                state.orders = payload.orders
                state.snapshot = payload.snapshot
                state.status = STATUS_IDLE
            })
            .addCase(fetchOrders.rejected, state => {
                state.status = STATUS_FAILED
            })
            .addCase(fetchOrders.pending, state => {
                state.status = STATUS_PENDING
            })
    }
})

export const selectOrders = state => state.orders

export default ordersSlice.reducer

